module.exports = __webpack_public_path__ + "img/BV.b0194431.png";